module.exports = __webpack_public_path__ + "static/img/client-egs.2c3c759.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/clients/client-egs.png
// module id = 72
// module chunks = 1